import { useEffect } from 'react';
import { getSocket } from '@/lib/socket';
import { useUserStore } from '@/stores/userStore';

export const useTimeSync = () => {
  const socket = getSocket();
  const { setTimeOffset } = useUserStore();

  useEffect(() => {
    const syncTime = () => {
      const t0 = Date.now();

      socket.emit('time:ping', { t0 }, (response: { t1: number }) => {
        const t2 = Date.now();
        const { t1 } = response;

        // Calculate round trip time and offset
        const roundTrip = t2 - t0;
        const serverTime = t1 + roundTrip / 2;
        const offset = serverTime - t2;

        console.log(`Time sync: offset=${offset}ms, roundTrip=${roundTrip}ms`);
        setTimeOffset(offset);
      });
    };

    // Sync time on connect and every 30 seconds
    if (socket.connected) {
      syncTime();
    }

    socket.on('connect', syncTime);

    const interval = setInterval(syncTime, 30000);

    return () => {
      socket.off('connect', syncTime);
      clearInterval(interval);
    };
  }, [socket, setTimeOffset]);
};
